import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerRightDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.707 14.293a1 1 0 0 0-1.414 1.414zM15 20l-.707.707a1 1 0 0 0 1.414 0zm5.707-4.293a1 1 0 0 0-1.414-1.414zM4 3a1 1 0 0 0 0 2zm7 1V3zm4 4h1zm-5.707 7.707 5 5 1.414-1.414-5-5zm6.414 5 5-5-1.414-1.414-5 5zM4 5h7V3H4zm7 0a3 3 0 0 1 2.121.879l1.415-1.415A5 5 0 0 0 11 3zm2.121.879A3 3 0 0 1 14 8h2a5 5 0 0 0-1.464-3.536zM14 8v12h2V8z"
    />
  </svg>
);
export default SvgCornerRightDown;
